export const ERROR_TYPES = {
  createError: 'CREATE_ERROR',
  updateError: 'UPDATE_ERROR',
  playError: 'PLAY_ERROR',
  timesUpError: 'TIMES_UP_ERROR',
  deleteError: 'DELETE_ERROR',
  archiveError: 'ARCHIVE_ERROR',
  unarchiveError: 'UNARCHIVE_ERROR',
  newTagError: 'NEW_TAG_ERROR',
  searchTagError: 'SEARCH_TAG_ERROR',
  selectDateError: 'SELECT_DATE_ERROR',
  finishError: 'FINISH_ERROR',
  addTagError: 'ADD_TAG_ERROR',
  removeTagError: 'REMOVE_TAG_ERROR'
}

export const TASK_STATUS = {
  stopped: 0,
  played: 1,
  paused: 2,
  timesUp: 3,
  finished: 4
}